import api from '../api'

export default {
    namespaced: true,
    state: {
        balance: 0,
        manualRechargeList: {
            beanList: [],
            total: 0
        }
    },
    mutations: {
        setStateBalance(state, info) {
            state.balance = info
        },
        setStateManualRechargeList(state, info) {
            state.manualRechargeList = info
        }
    },
    actions: {
        getBalance({commit}){
            return api.post('/manualRecharge/balance', '手工充值仓余额').then(res => {
                commit('setStateBalance', res.data)
            })
        },
        getManualRechargeList({commit}, params) {
            return api.post('/manualRecharge/logs', '手工充值仓修改记录', params).then(res => {
                commit('setStateManualRechargeList', res.data)
            })
        },
        updateBalance({dispatch},params){
            return api.post('/manualRecharge/update', '手工充值仓金豆修改',params).then(() => {
                dispatch('getBalance')
            })
        },
    }
}